import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

class Profiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <h1>Settings</h1>
      </div>
    );
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Profiles);



// WEBPACK FOOTER //
// ./src/views/Profiles/index.js